import {Avatar} from 'antd';
import { US, CA, CN, DE, FR, GB, CH, JP, MX } from 'country-flag-icons/react/3x2';


const countryCodeMap = {
  'united states': US,
  'us': US,
  'canada': CA,
  'mexico': MX,
    'germany': DE,
    'france': FR,
    'united kingdom': GB,
    'switzerland': CH,
    'japan': JP,
  'china': CN,
  'asia emerging': CN,
  'north america': US,
  // Add more countries as needed
};

const CountryFlag = ({ country }) => {
  const Icon = countryCodeMap?.[country?.toLowerCase?.()]
  return Icon ? <Icon style={{ width: '32px', height: '32x' }} /> : <Avatar>{country}</Avatar>;
};


export default CountryFlag;